<div [className]="currentOrder === null ? '' : 'd-none'">
  <nav class="navbar navbar-light bg-light mt-2">
    <form class="w-100">
      <div class="form-row">
        <div class="form-group col-12">
          <label for="filter">{{i18n.get('global_search_label')}}</label>
          <input id="filter" (keyup)="applyFilter($event)" [value]="filterObject.filtervalue"
                 (search)="applyFilter($event)"
                 (input)="filterObject.filtervalue = $event.target.value"
                 class="form-control" type="search" placeholder="{{i18n.get('orders_search_placeholder', 'orders')}}"
                 aria-label="Search">
          <small class="form-text text-muted">
            <!-- Placeholder for extra informations like default date range -->
          </small>
        </div>
      </div>
    </form>
  </nav>

  <table matTableExporter mat-table matSort [dataSource]="datalistsource" #exporter="matTableExporter">

    <ng-container *ngFor="let column of displayedColumns">

      <ng-container matColumnDef="{{column}}">
        <th mat-header-cell mat-sort-header [disabled]="column === 'actions'" class="pl-2 pr-2 text-capitalize"
            *matHeaderCellDef>{{getColumnLabel(column)}}</th>
        <td mat-cell *matCellDef="let element">
          <div class="ms-2 me-2">
            <ng-container *ngIf="column !== 'actions'">
              {{getFormattedValue(column, element[column])}}
            </ng-container>
            <ng-container *ngIf="column === 'actions'">
              <div class="btn-group">
                <button class="btn" (click)="showDetails(element)" title="{{i18n.get('global_details_label')}}"><i
                  class="fas fa-info-circle"></i></button>
              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>


  <div *ngIf="!datalistsource" class="alert text-center mt-1" role="alert">
    <i class="fa-spin fas fa-sync me-2"></i>Loading last DOS orders...
  </div>

  <div class="mb-5 btn-toolbar justify-content-between mt-2">
    <div>
      <mat-paginator [pageSizeOptions]="[20, 100, 500]" showFirstLastButtons></mat-paginator>
    </div>
    <div class="btn-group" *ngIf="datalistsource && datalistsource.data.length > 0">
      <button (click)="exporter.exportTable('csv', exportOptions)" type="button"
              class="btn btn-sm btn-outline-secondary"><i class="fas fa-file-csv me-2"></i>
        {{i18n.get('orders_export_csv_label', 'orders')}}
      </button>
      <button (click)="exporter.exportTable('xls', exportOptions)" type="button" class="btn btn-sm btn-outline-primary">
        <i class="fas fa-file-excel me-2"></i>
        {{i18n.get('orders_export_excel_label', 'orders')}}
      </button>
    </div>
  </div>
</div>

<!-- Order details -->
<ng-container *ngIf="currentOrder">
  <div class="container">
    <div class="row">
      <div class="col bg-white details-wrapper my-3 pt-3">
        <button class="btn btn-sm btn-light float-end d-lg-block"
                (click)="closeDetails()">{{i18n.get('global_back_to_list_label')}}</button>
        <app-dos-order-details [order]="currentOrder"></app-dos-order-details>
      </div>
    </div>
  </div>
</ng-container>
